module.exports = __webpack_public_path__ + "static/media/align-justify.a9e66771.svg";